import { put } from 'redux-saga/effects';
import EasyRedux from '../../../utils/EasyRedux';
import handleSagaError from '../../handleSagaError';
import { history } from '../../../utils';

const key = 'USERSITE/INFO';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetUserSiteInfo(
  client,
  { payload: { siteId, resolve, reject } }
) {
  try {
    const { result } = yield client.post('/site/home/siteInfo', {
      data: { site: siteId },
    });
    yield put(actions.loadSuccess(result));
    resolve && resolve(result);
  } catch (e) {
    reject && reject(e);
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
